module.exports = __webpack_public_path__ + "img/duplicate.fc364381.svg";